import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-taux-etudiant',
    templateUrl: './taux-etudiant.component.html',
    styleUrls: ['./taux-etudiant.component.scss']
})
export class TauxEtudiantComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
